const parsedProductId = parseInt(process.env.REACT_APP_PRODUCT_ID || '2', 10);
const defaultMainApiUrl = 'https://api.onahiri.app/api';
const defaultOtmsApiUrl = 'https://api.onahiri.app/api/otms';
const resolvedMainApiUrl = (
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_MAIN_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  defaultMainApiUrl
).trim().replace(/\/+$/, '');
const resolvedOtmsApiUrl = (
  process.env.REACT_APP_API_OTMS_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  defaultOtmsApiUrl
).trim().replace(/\/+$/, '');

export const appConfig = {
  productId: Number.isFinite(parsedProductId) ? parsedProductId : 2,
  appName: 'Onahiri App',
  api: {
    baseURL: resolvedOtmsApiUrl,
    mainURL: resolvedMainApiUrl,
  },
  paymentUrl: process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_PAYMENT_URL || 'http://localhost:3000/view-bill.html'
    : 'https://www.effimetic.com/view-bill.html',
  reactPaymentUrl: process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_REACT_PAYMENT_URL || 'http://localhost:3000/api/view-bill.html'
    : 'https://www.effimetic.com/api/view-bill.html',
  ws: {
    // Socket.IO expects an http(s) URL; it upgrades to websocket itself.
    getUrl: () => {
      if (process.env.REACT_APP_WS_URL) {
        return process.env.REACT_APP_WS_URL.replace(/\/+$/, '');
      }
      const hostname = process.env.REACT_APP_WS_HOSTNAME
        || new URL(resolvedMainApiUrl).host;
      const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
      return `${protocol}//${hostname}`;
    }
  }
};